<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    width?: string | number;
    height?: string | number;
    viewBox?: string;
    color?: string;
  }>(),
  {
    width: '16',
    height: '17',
    viewBox: '0 0 16 17',
    color: '#A3A3A3',
  }
);
</script>

<template>
  <svg
    :width="props.width"
    :height="props.height"
    :viewBox="props.viewBox"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M5.66667 2.78718L6.25 0.501465H9.75L10.3333 2.78718M15 2.78718H2.16667L3.33333 16.5015H12.6667L13.8333 2.78718H1H15ZM8 6.21575V13.0729V6.21575ZM10.9167 6.21575L10.3333 13.0729L10.9167 6.21575ZM5.08333 6.21575L5.66667 13.0729L5.08333 6.21575Z"
      :stroke="props.color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped>
svg {
  display: inline-block;
  vertical-align: middle;
}
</style>
